import gql from 'graphql-tag';

export const FILE_SUMMARY = gql`
  fragment FileSummary on File {
    id
    url
    filename
  }
`;
